// extracted by mini-css-extract-plugin
export default {"breadCumbContainer":"BreadCrumb_breadCumbContainer__gV7gc","link":"BreadCrumb_link__p3LWk"};